export function stratusProdFallbackUrl(input: string | null | undefined): string | null {
    const raw = String(input || '').trim();
    if (!raw) return null;

    try {
        const url = new URL(raw);
        const host = String(url.hostname || '').trim();
        if (!host) return null;
        const lowerHost = host.toLowerCase();
        if (!lowerHost.endsWith('.zohostratus.com')) return null;

        // In Catalyst, dev Stratus hosts are suffixed with "-development".
        // Example:
        //   https://propertyimages-development.zohostratus.com/...
        // Production equivalent:
        //   https://propertyimages.zohostratus.com/...
        if (!lowerHost.endsWith('-development.zohostratus.com')) return null;

        url.hostname = host.replace(/-development(?=\.zohostratus\.com$)/i, '');
        return url.toString();
    } catch {
        return null;
    }
}

function appOrigin(): string {
    const origin = typeof window !== 'undefined' ? String(window.location.origin || '').trim() : '';
    return origin.replace(/\/+$/, '');
}

export function stratusFileProxyUrl(input: string | null | undefined): string | null {
    const raw = String(input || '').trim();
    if (!raw) return null;

    try {
        const url = new URL(raw);
        const lowerHost = String(url.hostname || '').trim().toLowerCase();
        if (!lowerHost.endsWith('.zohostratus.com')) return null;

        const match = url.pathname.match(/\/files\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})(?:\/|$)/i);
        const fileId = match?.[1] ? String(match[1]).trim() : '';
        if (!fileId) return null;

        const lowerPath = String(url.pathname || '').toLowerCase();
        const endpoint = /\.(png|jpe?g|webp|gif|bmp|svg|avif)$/i.test(lowerPath)
            ? 'image'
            : 'public';
        const path = `/server/Files/${endpoint}/${encodeURIComponent(fileId)}`;
        const origin = appOrigin();
        return origin ? `${origin}${path}` : path;
    } catch {
        return null;
    }
}
